// @flow
// $FlowFixMe
import { Link, NavLink } from './linkv4';
// linkv4 заменится на linkv3 для лк с третьим роутером

export default Link;
export { NavLink };
